module.exports = __webpack_public_path__ + "img/banner-33.5857ec71.jpg";